// Compact macro context row above the dashboard: yields, FX, vol, commodities.
// Lives separately from the broader TickerTape that surfaces equities.

import { useTradingViewWidget } from './useTradingViewWidget';

const SYMBOLS = [
  { proName: 'TVC:US10Y', title: 'US 10Y' },
  { proName: 'TVC:UK10Y', title: 'UK 10Y' },
  { proName: 'TVC:DE10Y', title: 'DE 10Y' },
  { proName: 'FX:GBPUSD', title: 'GBP/USD' },
  { proName: 'FX:EURUSD', title: 'EUR/USD' },
  { proName: 'CAPITALCOM:VIX', title: 'VIX' },
  { proName: 'TVC:GOLD', title: 'Gold' },
  { proName: 'TVC:USOIL', title: 'Crude' },
  { proName: 'COINBASE:BTCUSD', title: 'BTC' },
];

export function MacroStrip() {
  const ref = useTradingViewWidget('embed-widget-ticker-tape', {
    symbols: SYMBOLS,
    showSymbolLogo: false,
    colorTheme: 'dark',
    isTransparent: true,
    displayMode: 'compact',
    locale: 'en',
  });

  return (
    <div className="rounded-xl border border-zinc-800 bg-zinc-950 overflow-hidden">
      <div className="px-3 pt-2 pb-1 flex items-baseline justify-between">
        <span className="text-[10px] uppercase tracking-wider text-zinc-400">Macro</span>
        <span className="text-[10px] text-zinc-400">yields · FX · vol · commodities</span>
      </div>
      <div ref={ref} className="tradingview-widget-container h-10" />
    </div>
  );
}
